/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Lesuur_KolomInputs */

const nl_planning_rooster_lesuur_kolom = /** @type {(inputs: Planning_Rooster_Lesuur_KolomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesuur`)
};

/**

* @param {Planning_Rooster_Lesuur_KolomInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_lesuur_kolom = /** @type {((inputs?: Planning_Rooster_Lesuur_KolomInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Lesuur_KolomInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_lesuur_kolom(inputs)
});
export { planning_rooster_lesuur_kolom as "planning.rooster.lesuur_kolom" }